import { useCallback, useState } from 'react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Text, TextType } from 'ui-components/components/text';

import style from './container-style.module.less';
import { messages } from './messages';
import { TodoCard } from './todo-card';
import { useShippingVolumeCategory } from '../../../../hooks/use-shipping-volume-category';

/**
 * TodoCardsContainer component for displaying a collapsible grid of TodoCard components
 * @param {object} props - Component props
 * @param {Array<object>} props.todoCards - Array of todo card data objects to display
 * @param {string} props.titleClassName - Additional CSS class name for the section title
 * @returns {React.ReactElement} The TodoCardsContainer component
 */
export const TodoCardsContainer = ({ todoCards, titleClassName }) => {
  const { isSmallTrialer } = useShippingVolumeCategory();
  const [isExpanded, setIsExpanded] = useState(!isSmallTrialer);

  const handleToggle = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  return (
    <div className={style['todo-cards-section']}>
      <div className={style['section-header']} onClick={handleToggle}>
        <Text
          className={`${style['section-title']} ${titleClassName ?? ''}`}
          textType={TextType.H4}
          value={messages.advancedOptionsTitle}
        />
        <FontAwesomeIcon className={style['expander-icon']} icon={isExpanded ? faChevronUp : faChevronDown} />
      </div>
      {isExpanded ? (
        <div className={style['cards-grid']}>
          {todoCards.map((card) => (
            <TodoCard key={card.id} description={card.description} id={card.id} link={card.link} title={card.title} />
          ))}
        </div>
      ) : null}
    </div>
  );
};
